export default "__VITE_ASSET__f7fa5519__"